export const maprecipeToProfessionalFormat = (recipe) => ({
  recipe_id: recipe?.id,
  url:recipe?.imageUrl,
  patient: {
    first_name: recipe?.patient?.first_name,
    last_name: recipe?.patient?.last_name,
    rut: recipe?.patient?.rut,
  },
  professional: {
    first_name: recipe?.professional?.first_name,
    last_name: recipe?.professional?.last_name ,
    rut: recipe?.professional?.rut,
    medical_center: recipe?.professional?.medical_center,
    email: recipe?.professional?.email,
  },
  expiration_date: recipe?.expiration_date,
  renewal_date: recipe?.renewal_date,
  check_number: recipe?.check_number,
  created_by: "692513b8864acbce65e4b307", // Momentanueos since remove field on backend
});
